import React, { useEffect, useState } from 'react';
import { RouteComponentProps, Redirect } from 'react-router-dom';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { Loading } from 'react-style-guide';
import { TPageType, TOmniRecommendationSort } from '../common/types/bedev1Types';
import bedev1Services from '../common/services/bedev1Services';
import bedev2Services from '../common/services/bedev2Services';
import experimentConstants from '../common/constants/experimentConstants';
import { CommonGameSorts } from '../common/constants/translationConstants';
import ErrorStatus from '../common/components/ErrorStatus';
import { THomepagePersonalizationVariation } from '../common/types/experimentTypes';
import gameCarouselTranslationConfig from '../../../js/react/gameCarousel/translation.config';
import SortDetailGrid from './SortDetailGrid';

const { layerNames, defaultValues } = experimentConstants;

export const SortDetail = ({
  match,
  translate
}: RouteComponentProps<{ sortName: string }> & WithTranslationsProps): JSX.Element => {
  const sortName = decodeURIComponent(match.params.sortName);
  const [sort, setSort] = useState<TOmniRecommendationSort | undefined>(undefined);
  const [variation, setVariation] = useState<boolean | undefined>(undefined);
  const [redirect, setRedirect] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const fetchRecommendations = async () => {
    setError(false);
    setSort(undefined);
    try {
      const omniRecommendations = await bedev1Services.getOmniRecommendations(TPageType.Home);
      const selectedSort = omniRecommendations.Sorts.find(sortItem => sortItem.Topic === sortName);
      if (selectedSort === undefined) {
        setRedirect(true);
      } else {
        setSort(selectedSort);
      }
    } catch {
      setError(true);
    }
  };

  const fetchVariation = async () => {
    const data = await bedev2Services.getExperimentationValues(
      layerNames.homePage,
      defaultValues.homePage
    );
    setVariation(data.UseOmniRecommendation);
  };

  useEffect(() => {
    // eslint-disable-next-line no-void
    void fetchVariation();
  }, []);

  useEffect(() => {
    // eslint-disable-next-line no-void
    void fetchRecommendations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortName]);

  // // Error in API calls
  if (error) {
    return (
      <div className='game-sort-detail-container'>
        <h3>{translate(CommonGameSorts.LabelGames)}</h3>
        <div className='game-sort-detail'>
          <ErrorStatus
            errorMessage={translate(CommonGameSorts.LabelApiError)}
            onRefresh={fetchRecommendations}
          />
        </div>
      </div>
    );
  }
  // Redirect if V1 or recommendation cannot be found
  if (variation === THomepagePersonalizationVariation.Default || redirect) {
    return <Redirect to='/' />;
  }
  // V2 experience and recommendations is loaded
  if (variation === THomepagePersonalizationVariation.V2 && sort) {
    return (
      <div className='game-sort-detail-container'>
        <h3>{sortName}</h3>
        <SortDetailGrid sort={sort} translate={translate} />
      </div>
    );
  }

  return <Loading />;
};

export default withTranslations(SortDetail, gameCarouselTranslationConfig);
